/**
 * Le QR code délivré par la banque, réduit pour tenir dans les réglages de
 * l'entreprise : 600 pixels au plus, en PNG, sans lissage pour que les modules
 * du QR restent nets et lisibles par les applications bancaires.
 *
 * @param {Blob} fichier image choisie (capture ou fichier de la banque)
 * @param {number} [cote] plus grand côté, en pixels
 * @returns {Promise<string>} l'image en adresse data:
 */
export function reduisImageQr(fichier, cote = 600) {
  return new Promise((resolve, reject) => {
    const lecteur = new FileReader();
    lecteur.onerror = () => reject(new Error('Image illisible'));
    lecteur.onload = () => {
      const image = new Image();
      image.onerror = () => reject(new Error('Image illisible'));
      image.onload = () => {
        const echelle = Math.min(1, cote / Math.max(image.width, image.height));
        const toile = document.createElement('canvas');
        toile.width = Math.round(image.width * echelle);
        toile.height = Math.round(image.height * echelle);
        const dessin = toile.getContext('2d');
        dessin.imageSmoothingEnabled = false;
        dessin.fillStyle = '#fff';
        dessin.fillRect(0, 0, toile.width, toile.height);
        dessin.drawImage(image, 0, 0, toile.width, toile.height);
        resolve(toile.toDataURL('image/png'));
      };
      image.src = lecteur.result;
    };
    lecteur.readAsDataURL(fichier);
  });
}
